module.exports = __webpack_public_path__ + "static/media/no-journal-default.52821a09.png";